<label
  class="fi-radio"
  [class.fi-radio--block]="block"
  [class.fi-radio--error]="!!error"
  [class.fi-radio--disabled]="disabled"
>
  <span class="fi-radio__control">
    <input
      type="radio"
      class="fi-radio__input"
      [name]="name"
      [checked]="checked"
      [disabled]="disabled"
      (change)="onInputChange($event)"
    >
    <span class="fi-radio__box"></span>
  </span>

  <span class="fi-radio__text">
    <span class="fi-radio__label">
      <ng-content></ng-content>
      <span *ngIf="required" class="fi-radio__required">&nbsp;*</span>
    </span>
    <span *ngIf="hint" class="fi-radio__hint">{{ hint }}</span>
    <span *ngIf="error" class="fi-radio__error-text">{{ error }}</span>
  </span>
</label>
